<div class="login-box" *ngIf="setExpiry">
  <h2 class="sign-in">{{ "TOKEN_EXPIRED" | translate }}</h2>
  <p class="login-desc">{{ "GENERATE_PASSWORD_TOKEN" | translate }}</p>
  <button
    type="submit"
    class="btn blue-gredient-btn form-control w-100 justify-content-center"
    mat-button
    mat-flat-button
    routerLink="/reset_password"
  >
    {{ "BUTTON" | translate }}
  </button>
</div>
<div class="login-box" *ngIf="!setExpiry">
  <h2 class="sign-in">{{ "HEADER" | translate }}</h2>
  <p class="login-desc password-assitance">
    {{ "PASSWORD_ASSISTANCE" | translate }}
  </p>
</div>
<div class="login-form-elements">
  <form class="example-form" [formGroup]="setPassForm" *ngIf="!setExpiry">
    <div class="row">
      <div class="col-12">
        <mat-form-field
          appearance="standard"
          class="custom-input-field custom-input-choose-new-pswrd w-100 mb-3"
        >
          <mat-label>{{ "CHOOSE_NEW_PASSWORD" | translate }}</mat-label>
          <img
            matPrefix
            src="../../../assets/icons/login-password-logo.svg"
            alt="login-logo"
            draggable="false"
          />
          <input
            type="password"
            matInput
            placeholder=""
            (paste)="checkInput($event, 'password')"
            (keydown)="checkInput($event, 'password')"
            [type]="showPassword ? 'text' : 'password'"
            matInput
            formControlName="password"
          />
          <img
            tabindex="0"
            (keypress)="$event.keyCode == 13 && togglePasswordVisibility()"
            [src]="
              showPassword
                ? './assets/icons/24.svg'
                : './assets/icons/login-show-pwd.svg'
            "
            alt="showPassword"
            (click)="togglePasswordVisibility()"
            style="z-index: 5"
            alt="showPassword"
            matSuffix
            style="pointer-events: auto"
            draggable="false"
          />
          <mat-error
            *ngIf="setPassForm.controls['password'].hasError('required')"
          >
            {{ "PASSWORD_REQUIRED" | translate }}</mat-error
          >
          <mat-error
            *ngIf="setPassForm.controls['password'].hasError('pattern')"
          >
            {{ "PASSWORD_PATTERN" | translate }}</mat-error
          >
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field
          appearance="standard"
          class="custom-input-field w-100 mb-3"
        >
          <mat-label>{{ "CONFIRM_NEW_PASSWORD" | translate }}</mat-label>
          <img
            matPrefix
            src="../../../assets/icons/login-password-logo.svg"
            alt="login-password-logo"
            draggable="false"
          />
          <input
            type="password"
            matInput
            placeholder=""
            (paste)="checkInput($event, 'confirmPassword')"
            (keydown)="checkInput($event, 'confirmPassword')"
            [type]="confirmShowPassword ? 'text' : 'password'"
            matInput
            formControlName="confirmPassword"
          />
          <img
            tabindex="0"
            (keypress)="
              $event.keyCode == 13 && toggleConfirmPasswordVisibility()
            "
            [src]="
              confirmShowPassword
                ? './assets/icons/24.svg'
                : './assets/icons/login-show-pwd.svg'
            "
            alt="confirmShowPassword"
            (click)="toggleConfirmPasswordVisibility()"
            style="z-index: 5"
            alt="confirmShowPassword"
            matSuffix
            style="pointer-events: auto"
            draggable="false"
          />
          <mat-error
            *ngIf="setPassForm.controls['confirmPassword'].hasError('required')"
          >
            {{ "CONFIRM_PASSWORD_REQUIRED" | translate }}</mat-error
          >
          <mat-error
            *ngIf="
              setPassForm.controls['confirmPassword'] &&
              !setPassForm.controls['confirmPassword'].hasError('required')
            "
          >
            {{ "CONFIRM_PASSWORD_NOT_MATCH_WITH_OLD" | translate }}</mat-error
          >
        </mat-form-field>
      </div>
    </div>
    <div class="align-login-btn">
      <button
        type="submit"
        class="btn blue-gredient-btn form-control w-100 justify-content-center"
        mat-button
        mat-flat-button
        (click)="resetPassword()"
      >
        Set New Password
      </button>
    </div>
  </form>
  <p class="botom-action-line">
    {{ "SIGN_UP_LINE" | translate }}
    <span class="sign-up-now" routerLink="/signUp">{{
      "SIGN_UP_NOW" | translate
    }}</span>
  </p>
</div>
